const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

async function refreshToken() {
  const refresh = localStorage.getItem('refresh_token');
  if (!refresh) return null;
  const res = await fetch(`${API_URL}/token/refresh/`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ refresh })
  });
  if (res.ok) {
    const data = await res.json();
    localStorage.setItem('access_token', data.access);
    return data.access;
  } else {
    // refresh токен невалиден, разлогиниваем пользователя
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    window.location.reload();
    return null;
  }
}

export default async function authFetch(url, options = {}, retry = true) {
  let token = localStorage.getItem('access_token');
  const headers = {
    ...(options.headers || {}),
    ...(token ? { 'Authorization': `Bearer ${token}` } : {})
  };
  const response = await fetch(url, { ...options, headers });

  if (response.status === 401 && retry) {
    // Пробуем обновить токен и повторить запрос
    token = await refreshToken();
    if (token) {
      const retryHeaders = {
        ...(options.headers || {}),
        'Authorization': `Bearer ${token}`
      };
      return fetch(url, { ...options, headers: retryHeaders });
    }
  }
  return response;
} 